import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { FieldWrapper, FormlyFieldConfig, FormlyFieldProps, FormlyModule } from '@ngx-formly/core';
import { SafeHtmlPipe } from '~ngx-shared/pipes';

export interface FieldWrapperProps extends FormlyFieldProps {
  hideRequiredMarker?: boolean;
  disableMargin?: boolean;
  hideLabel?: boolean;
  labelClass?: string;
  header?: string;
  headerClass?: string;
  footer?: string;
  footerClass?: string;

  [key: string]: any;
}

@Component({
  selector: 'lib-formly-field-wrapper',
  templateUrl: './field-wrapper.component.html',
  styleUrl: './field-wrapper.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslocoDirective, NgClass, FormlyModule, SafeHtmlPipe]
})
export class FieldWrapperComponent extends FieldWrapper<FormlyFieldConfig<FieldWrapperProps>> {}
